import { render, staticRenderFns } from "./NsrItemList.vue?vue&type=template&id=24df7eca"
import script from "./NsrItemList.vue?vue&type=script&lang=js"
export * from "./NsrItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports